import React, { useEffect, useState } from 'react'
import styled, { withTheme } from 'styled-components';
import {
    BodyWrapper as MessageBodyWrapper,
    FirstCol,
    Header,
    MainInfoWrapper,
} from 'src/components/udb/commonStyle';
import Intl from 'src/components/common/Intl';
import UDBHeader from 'src/components/UDBHeader';
import config from 'src/config/config';
import { Tittle } from './Auth/commonStyles';
import Breadcrumb from './udb/Breadcrumb';
import { theme } from 'styled-tools';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import SEOContents from './SEOContents';
import { useLocation } from 'react-router-dom';
import { MetaProps, SEOFooterCommon, SEOMetaCommon } from './SEOMetaCommon';
import { withAppContext } from 'src/store/initAppContext';
import { otherPagesSEOData } from 'src/config/seo_api';

const AffiliateHome = (props: any) => {
    const { app: { brandId } ,theme } = props;
    const { config: {showAPISEOData}} = theme;
    const [seoObjects, setseoObjects] = useState({} as MetaProps);
    const _location = useLocation();
    //for SEO
    useEffect(() => {
        if (showAPISEOData) {
            const getSeoData = otherPagesSEOData();
            const pathName = _location.pathname;

            getSeoData.then(resp => {
                const { objects } = resp;
                const seoData = objects.find((obj: any) => {
                    const { metadata = {} } = obj;
                    if (metadata.pathname && metadata.pathname === pathName) {
                        return obj;
                    }

                }) || {};

                const { metadata = {} } = seoData;
                setseoObjects(metadata);

            }).catch(error => console.log(`[${pathName}]:Error in SEO API`))
        }
    }, []);
    
    return (<>
        {!showAPISEOData && <SEOContents pageName="affiliate" />}
        {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}
        <MainInfoWrapper>

            <AffiliateWrapper>
                <HeaderContainer>
                    <FirstCol>
                        <Tittle>
                            <Intl langKey="DASHBOARD@AFFILIATE" />
                        </Tittle>
                        <Breadcrumb />
                    </FirstCol>
                </HeaderContainer>
                <BodyWrapper>
                    {/* <Title> <Intl langKey='TABLE@COMING_SOON' /></Title> */}
                    <LazyLoadImage src={`${config.imageV3Host}/static/media/ComingSoonDesktopVersion.jpg`} effect="none" height="100%" width="100%" placeholder={<PlaceholderImage />} />
                </BodyWrapper>
            </AffiliateWrapper>
        </MainInfoWrapper>
        {showAPISEOData && <SEOFooterCommon footer_title={seoObjects['seo_footer_title_(h1)']} footer_content={seoObjects['seo_footer_content']} />}
    </>
    )
}

export default withTheme(withAppContext(AffiliateHome));

const BodyWrapper = styled(MessageBodyWrapper)`
    width: 100%;
    justify-content: center;
    background: none;
    box-shadow: none;
    border-radius: 5px;
    padding: 0em;

    img {
        max-width: 100%;
        object-fit: cover;
        height: 100%;
        border-radius: 5px;;
    }
`;
const AffiliateMain = styled.div`
    padding: 2rem;
`
const AffiliateWrapper = styled.div`
    height: auto;
    min-height: 100vh;
    max-height: fit-content;
    box-shadow: 0px 0px 100px rgba(0, 7, 66, 0.77);
    width: 100%;
    padding: 3rem;
    /* background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.bonusBg')}); */
    background-repeat: no-repeat;
    background-size: cover;
    `


const HeaderContainer = styled.div`
    display: block;
    width:60%;
`

